import React, { useState,useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

import { capitalize } from "../../../services/utility/helper";
import { leaveService } from "../../../services/extensions";
import { LeaveStatus } from "../../../common/util/constants";
import { utitService } from "../../../services/util";
import { selectData } from "../../../services/store/userSlice";
import { Util } from "../../../services";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { ViewLeave } from "./view-leave";
import ConfirmBox from "../../../components/confirmbox/confirmbox";
import DateColumn from "../components/DateColumn";

const Approved = ({ leaves, reload }) => {
  const userData = useSelector(selectData);
  const { user } = useSelector((state) => state.user);
  const [selectedLeaves, setSelectedLeaves] = useState([]);
  const [editingRows, setEditingRows] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [selLeave, setSelLeave] = useState([]);
  const [selLeaves, setSelLeaves] = useState({});
  const [viewDialog, setViewDialog] = useState(false);
  const [viewTabIndex, setViewTabIndex] = useState(0);
  const [region, setRegion] = useState("ESIN");

  useEffect(() => {
    if (user) {
      const leCode = user?.LegalEntity?.code || "ESIN";
      setRegion(leCode);
    }
  }, [user]);

  const recallById = (reason) => {
    const ids = selLeave.map((x) => x.id);
    if (ids.length == 0) {
      toast.error("No leaves selected");
      return;
    }
    const payload = { Ids: ids, recallReason: reason };
    leaveService
      .recallApprovedLeave(payload)
      .then((resp) => {
        toast.info(
          "Your recall request has been sent to your manager. Please wait for approval.",
        );
        setSelLeave([]);
        setSelectedLeaves([]);
        reload();
      })
      .catch((error) => {
        // For Australia region, show API error message; for others, show generic message
        let errorMessage = "Unable to recall leave";
        if (region === "ESAU") {
          errorMessage = 
            error?.response?.data?.message || 
            error?.response?.data?.error || 
            "Unable to recall leave";
        }
        toast.error(errorMessage);
      });
  };


  const recallLeave = (row, op) => {
    setSelLeave([row]);
    setShowDialog(true);
  };

  const viewLeave = (row) => {
    setSelLeaves(row);
    setViewDialog(true);
  };

  const renderActions = (rowData, options) => {
    const disabledRecall = false;
    return (
      <>
        {rowData.attachment !== null && (
          <Button
            icon="pi pi-link"
            className="p-button-rounded p-button-text p-button-warning"
            aria-label="Document"
            onClick={() => viewLeave(rowData, 1)}
          />
        )}
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-text"
          aria-label="Edit"
          onClick={() => viewLeave(rowData, 0)}
        />
        <Button
          icon="pi pi-replay"
          disabled={rowData.recallReason !== ""}
          className="p-button-rounded p-button-text p-button-danger"
          aria-label="Recall"
          onClick={(e) => recallLeave(rowData, options)}
        />
      </>
    );
  };

  const renderLeaveHours = (rowData) => {
    if (!rowData.leaveHours || rowData.leaveHours <= 0) return "-";
    return <strong>{rowData.leaveHours}</strong>;
  };

  const renderAbsenceCode = (rowData, options) => {
    return (
      <>
        <strong>{rowData.absenceCode}</strong>
        {userData.absenceCode && (
          <em> ({userData?.absenceCode[rowData.absenceCode]?.title})</em>
        )}
      </>
    );
  };
  const renderAbsenceDuration = (rowData, options) => {
    return (
      <>
        <strong>{rowData.leaveType}</strong>
        {userData.leaveCode && (
          <em> ({userData?.leaveCode[rowData.leaveType]?.title})</em>
        )}
      </>
    );
  };
  const renderReasonOfLeave = (rowData, options) => {
    const reason = rowData[options.field] || "";
    const txt = reason.substr(0, 200);
    return (
      <>
        <span className="noet">{txt}</span>
      </>
    );
  };

  const submitLeaves = () => {
    setSelLeave(selectedLeaves);
    setShowDialog(true);
  };
  const rowClass = (data) => {
    return {
      recalled: data.recallReason !== "",
    };
  };

  return (
    <div>
      <ConfirmBox
        title="Recall Leave"
        message="Please mention your reason to recall this leave."
        placeholder="Enter reason for recall leave record"
        visible={showDialog}
        onCancel={() => setShowDialog(false)}
        onConfirm={recallById}
        required={true}
      />
      <DataTable
        value={leaves}
        responsiveLayout="scroll"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        selection={selectedLeaves}
        onSelectionChange={(e) =>
          setSelectedLeaves(e.value.filter((x) => x.recallReason === ""))
        }
        selectionMode="multiple"
        editMode="row"
        editingRows={editingRows}
        rowClassName={rowClass}
        dataKey="id"
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
          body={(row) => (row.recallReason !== "" ? "" : null)}
        />
        <Column
          field="startDate"
          header="Start Date"
          headerStyle={{ width: "130px" }}
          body={DateColumn}
        />
        <Column
          field="endDate"
          header="End Date"
          headerStyle={{ width: "130px" }}
          body={DateColumn}
        />
        {region === "ESAU" && (
          <Column
            field="leaveHours"
            header="Hours"
            headerStyle={{ width: "100px" }}
            body={renderLeaveHours}
          />
        )}
        {/* <Column header="Day" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} /> */}
        <Column
          field="absenceCode"
          header="Absence Code"
          headerStyle={{ width: "220px" }}
          body={renderAbsenceCode}
        />
        <Column
          field="leaveType"
          header="Leave Type"
          headerStyle={{ width: "180px" }}
          body={renderAbsenceDuration}
        />
        <Column
          field="reasonOfLeave"
          header="Reason of leave"
          body={renderReasonOfLeave}
        />
        <Column
          field="reason"
          header="Approver Message"
          body={renderReasonOfLeave}
        />
        <Column
          field="recallReason"
          header="Recall Reason"
          body={renderReasonOfLeave}
        />
        <Column
          header="Actions"
          headerStyle={{ width: "130px", textAlign: "center" }}
          bodyStyle={{ textAlign: "center" }}
          body={renderActions}
        />
        {/* <Column rowEditor tooltip="Edit Leave" header="Action" headerStyle={{ width: "100px", textAlign: 'right' }} bodyStyle={{ textAlign: 'right' }} /> */}
      </DataTable>
      <div className="field col flex p-0 m-0 mt-3">
        <Button
          label="Recall All"
          className="p-button-primary mr-2"
          icon="pi pi-replay"
          onClick={submitLeaves}
          disabled={selectedLeaves.length === 0}
        />
      </div>
      {ViewLeave({
        visible: viewDialog,
        onHide: () => setViewDialog(false),
        style: { width: "900px" },
        leave: selLeaves,
        header: "Leave Details",
        tabIndex: viewTabIndex,
      })}
    </div>
  );
};
export default Approved;
